export const sizes = {
  body: { width: 63, height: 92 },
  glasses: { width: 76 },
  eye: { width: 4.5 },
  mouth: { width: 12.5 },
  shadow: { width: 51 },
  star1: { width: 12.5 },
  star2: { width: 6.5 },
  particle1: { width: 10 },
  particle2: { width: 5 },
};

export type PositionConfig = {
  bodyLeft: number;
  bodyTop: number;
  glassesLeft: number;
  glassesTop: number;
  eyeLLeft: number;
  eyeLTop: number;
  eyeRLeft: number;
  eyeRTop: number;
  mouthLeft: number;
  mouthTop: number;
  shadowLeft: number;
  star1Left: number;
  star1Top: number;
  star2Left: number;
  star2Top: number;
  particle1Left: number;
  particle1Top: number;
  particle2Left: number;
  particle2Top: number;
};

function mirrorConfig(config: PositionConfig): PositionConfig {
  return {
    ...config,
    bodyLeft: 100 - config.bodyLeft - sizes.body.width,
    glassesLeft: 100 - config.glassesLeft - sizes.glasses.width,
    eyeLLeft: 100 - config.eyeRLeft - sizes.eye.width,
    eyeRLeft: 100 - config.eyeLLeft - sizes.eye.width,
    eyeLTop: config.eyeRTop,
    eyeRTop: config.eyeLTop,
    mouthLeft: 100 - config.mouthLeft - sizes.mouth.width,
    shadowLeft: 100 - config.shadowLeft - sizes.shadow.width,
    star1Left: 100 - config.star1Left - sizes.star1.width,
    star2Left: 100 - config.star2Left - sizes.star2.width,
    particle1Left: 100 - config.particle1Left - sizes.particle1.width,
    particle2Left: 100 - config.particle2Left - sizes.particle2.width,
  };
}

export const rightConfig: PositionConfig = {
  bodyLeft: 34,
  bodyTop: 8,
  glassesLeft: 29,
  glassesTop: 5,
  eyeLLeft: 46,
  eyeLTop: 18,
  eyeRLeft: 78.5,
  eyeRTop: 16.5,
  mouthLeft: 57,
  mouthTop: 32.5,
  shadowLeft: 28,
  star1Left: 18,
  star1Top: 10,
  star2Left: 14.5,
  star2Top: 8,
  particle1Left: 26,
  particle1Top: 68,
  particle2Left: 14.5,
  particle2Top: 63,
};

const straightConfig: PositionConfig = {
  bodyLeft: 18.5,
  bodyTop: 8,
  glassesLeft: 14,
  glassesTop: 5,
  eyeLLeft: 31.5,
  eyeLTop: 18,
  eyeRLeft: 64,
  eyeRTop: 18,
  mouthLeft: 43.75,
  mouthTop: 32.5,
  shadowLeft: 24.5,
  star1Left: 3,
  star1Top: 14,
  star2Left: 79,
  star2Top: 13,
  particle1Left: 75,
  particle1Top: 65,
  particle2Left: 8,
  particle2Top: 60,
};

export const directionConfigs: Record<string, PositionConfig> = {
  right: rightConfig,
  straight: straightConfig,
  left: mirrorConfig(rightConfig),
};
